export default __webpack_public_path__ + "static/last2-29f1361f40099789df8edba01baeeea1.png";